function toNumber(value) {
  const normalized = Number(value);

  return Number.isFinite(normalized) ? normalized : null;
}

function getQuotationFallback(order = {}) {
  if (!order?.quotation) {
    return {};
  }

  const quotationNum = 1;
  const workerFeeTotal = Array.isArray(order.quotation.worker_fee)
    ? order.quotation.worker_fee.reduce((sum, item) => sum + (toNumber(item?.price) || 0), 0)
    : 0;
  const serviceFee = toNumber(order.quotation.service_fee) || 0;

  if (workerFeeTotal <= 0) {
    return { quotationNum };
  }

  const quotationMinPrice = process.env.APP_MODE === 'manager'
    ? workerFeeTotal - serviceFee
    : workerFeeTotal + serviceFee;

  return {
    quotationNum,
    quotationMinPrice,
  };
}

function normalizeQuotationSummary(order = {}) {
  const quotationNum = toNumber(order?.quotationNum);
  const quotationMinPrice = toNumber(order?.quotationMinPrice);
  const fallback = getQuotationFallback(order);

  return {
    quotationNum: quotationNum ?? fallback.quotationNum ?? 0,
    quotationMinPrice: quotationMinPrice ?? fallback.quotationMinPrice ?? null,
  };
}

export function shouldShowQuotationSummary(user) {
  return process.env.APP_MODE === 'tenant' && user?.get('isSeeMaster') == 1;
}

export function shouldShowQuotationSummaryForOrder(order = {}, user) {
  return shouldShowQuotationSummary(user) && Number(order?.status_code) === 3001 && hasQuotationSummary(order);
}

export function hasQuotationSummary(order = {}) {
  const { quotationNum, quotationMinPrice } = normalizeQuotationSummary(order);
  const hasMinPrice = quotationMinPrice != null;

  return quotationNum > 0 || hasMinPrice;
}

export function getQuotationSummary(order = {}) {
  const { quotationNum, quotationMinPrice } = normalizeQuotationSummary(order);
  const hasMinPrice = quotationMinPrice != null;

  return {
    quotationNum,
    quotationNumText: `${quotationNum}人`,
    quotationMinPriceText: hasMinPrice ? `￥${quotationMinPrice.toFixed(2)}` : '--',
  };
}
